import React, { useEffect, useState } from 'react';
import * as S from './style';
export interface IOptionType {
  name: string;
  value: string | number;
}
export interface Props {
  inputName: string;
  children: Array<IOptionType>;
  value?: string | string[] | number;
  disabled?: boolean;
  onChangeHandler?: (type: any, value: string) => void;
}

function SelectBox({
  inputName,
  children,
  onChangeHandler,
  value,
  ...props
}: Props): React.ReactElement {
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChangeHandler) {
      const { name, value } = e.target;
      onChangeHandler(name, value);
      setIsSelected(e.target.options.selectedIndex !== 0);
    }
  };

  // 선택된 value가 변경되었고 값이 없을 경우, isSelected를 false로 초기화
  useEffect(() => {
    if (!value) {
      setIsSelected(false);
    }
  }, [value]);

  return (
    <S.Select
      name={inputName}
      onChange={onChange}
      value={value}
      selected={isSelected || !!value}
      {...props}
    >
      {children.map((item, index) => (
        <option key={index} value={item.value}>
          {item.name}
        </option>
      ))}
    </S.Select>
  );
}

export default SelectBox;
